import React, { useEffect, useState } from "react";
import { Button, Grid, makeStyles, CircularProgress } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import AuthWrapper from "../authWrapper";
import CustomTextField from "../../../common-components/CustomTextField";
import { forgotPasswordAPI } from "../../../api/admin-api";
import { useDispatch } from "react-redux";
import { setForgotPasswordEmail } from "../../../reducers/forgot-password-reducer";
import ActionMessages from "../../../common-components/ActionMessages";

// Styles
const useStyles = makeStyles((theme) => ({
  fullPageWrapper: {
    height: "100vh",
    backgroundColor: "#fafafa",
    position: "relative",
  },
  formWrapper: {
    margin: "0 31% 0 30%",
    width: "35%",
    height: "300px !important",
    position: "absolute !important",
    top: "20% !important",
  },
  welcomeWrapper: {
    padding: theme.spacing(4),
    background: "#ffffff",
    borderRadius: 8,
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  welcomeHead: {
    fontSize: 24,
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    textAlign: "center",
  },
  loginNote: {
    fontSize: 16,
    marginBottom: theme.spacing(3),
    textAlign: "center",
  },
  fieldStyle: {
    width: "60%",
    margin: "8px auto",
  },
  loginBtn: {
    textTransform: "none",
    borderRadius: theme.spacing(3),
    background: "#0176D3 !important",
    fontWeight: 500,
    width: "60%",
    marginTop: theme.spacing(4),
    padding: "12px 0 !important",
  },
  dangerText: {
    color: "red",
  },
  loadingText: {
    textAlign: "center",
    marginTop: theme.spacing(2),
    color: "#555",
  },
}));

function Emailverify() {
  const dispatch = useDispatch();

  const classes = useStyles();
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [loading, setLoading] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isErrOpen, setIsErrOpen] = useState(false);

  useEffect(() => {
    const emailId = localStorage.getItem("emailid");
    if (emailId) setEmail(emailId);
  }, []);

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const emailChange = (event) => {
    const value = event.target.value;
    setEmail(value);

    if (!value) {
      setEmailError("Email is required");
    } else if (!validateEmail(value)) {
      setEmailError("Enter a valid email address");
    } else {
      setEmailError("");
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!email) {
      setEmailError("Email is required");
      return;
    }
    if (!validateEmail(email)) {
      setEmailError("Enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      const res = await forgotPasswordAPI(email);

      if (res.status != 200) {
        setMsgType("error");
        setMsgText(res.message);
        setIsErrOpen(true);
      } else {
        setMsgType("success");
        setMsgText("OTP sent successfully!");
        setIsErrOpen(true);

        setTimeout(() => {
          dispatch(setForgotPasswordEmail(email));
        }, 10);

        setTimeout(() => {
          history.push("/otpvalidate");
        }, 2000);
      }
    } catch (error) {
      setMsgType("error");
      setMsgText("Couldn't send the OTP. Please try again.");
      setIsErrOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const errToggler = () => {
    setIsErrOpen((prev) => !prev);
  };

  return (
    <>
      <AuthWrapper>
        <Grid item lg={12} className={classes.welcomeHead}>
          <span>Change/Forgot Password</span>
        </Grid>
        <Grid item lg={12} className={classes.loginNote}>
          Verify your registered email to reset your password
        </Grid>
        <Grid item lg={12}>
          <div className={classes.fieldStyle}>
            <CustomTextField
              selectedValue={email}
              onChangeItem={emailChange}
              labelVal="Email ID"
              id="emailId"
              errorValue={!!emailError}
              helperText={
                emailError && (
                  <span className={classes.dangerText}>{emailError}</span>
                )
              }
              isLoginField={true}
            />
          </div>
        </Grid>

        <Grid item lg={12}>
          <Button
            variant="contained"
            color="primary"
            disableElevation
            className={classes.loginBtn}
            type="button"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Loading..." : "Send OTP"}
          </Button>
        </Grid>

        {loading && (
          <Grid item lg={12} className={classes.loadingText}>
            <CircularProgress size={24} style={{ marginRight: 8 }} />
            Sending OTP...
          </Grid>
        )}
      </AuthWrapper>
      {isErrOpen && (
        <ActionMessages
          type={msgType}
          isClosed={errToggler}
          message={msgText}
        />
      )}
    </>
  );
}

export default Emailverify;
